var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRf7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_634)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "url(#pattern0_874_634)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_874_634",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_874_634",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_874_634",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAC40lEQVRYw+1XS0wTQRhe6DebpbGGYIKCoBiVoMZQo0KMxihGUaw1iE/EpDESkJD4iAcPHiUefCcaI+oB7UEPXky8GV+B+DgY9Egk0WhQg4gVAQtt16/bDRLb7rZ0e+v8SXdmuv/37cz8/zczkqQVh4Jr+IEOeZqUjiIX4DV+4wx8eOJQLIcX5fiED1gqSajALzxwwFJ41GAIL5Cvt9ZjFF41y0qCz7g3eVrgxjiuWkkwPaqnASG0TQlrCY7hDi6g3p5j/GIrVJxIDlwROM2xD+ARuvnswSpjilOkOJTU15/j6h2JrB7mkGYYC4wdziOIXQnDr+TbTZMCX8Y7PDNzugU/qhMkaMP7/3q2QxUz4k1Pt26D/K6eiZaR+agDkdobVOnJq2JTbAIPo2gQl3ARl5mAzAvWzKwHvfy9Sc8BsUhDWUiCeAtNigBuVGYzNuzowjeUmk7RSfQjH52MomV6TxMCBsGKPQw170wbKXLxFh9RbEJQhJ/o+wcvCvEd7cYubvzBKzSjEcfxFV+YQo0G1kpFCOGxKHdAzkM9PXqFw0wE6+iiciR+WojL7Y9rAb7HMOVIVbZU2m0lN5HgO0rgfjmPZGWc4+ex5xTF1GAtZxQhnDiIbXJB4lLerEUUtRbLGYoPFREFP5dqHETd1MXQQ3efmE2ytRjB3cpsew5cil0Uav+WcKMKojY1vd1LiCGUsLaVK3IdpeiMaI5tHhUnCHfKkm6rJcxwOBuwj7UWnXg++wLCZcmuIbYwUkZFeFt1CaeeqSOEr7FuY9qgBewKvVUWhsdmycqCNRijrWZtMRUqEEfKUpqoCo5hHIeZ4wGxUUpHgZPg4eyuktJVsJMEDVL6CjdHNaL4GYIMQYYgQ5AhSIFgN+W6On3w+3mSGOMRbEcawHktusKvb+fh1svnWasv7EV4yZOER2+1cHd+Ks+yDn4dD78hXgwPTFh4NH0ml9UkCO5rh/Jo67BsDGpWLDP3+wtOkiUTaDF7MQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRf7);
export default __webpack_public_path__ + "static/media/rf7.20dcbdfc1d5b0d0e08736195d20394f9.svg";
export { ForwardRef as ReactComponent };